<template>
  <div class="auth-page">
    <div class="auth-wrap">
      <div class="auth-header clearfix">
        <img src="../../assets/img/passport/reg_logo.png" class="fl" />
        <h3 class="fl ml-20 pl-10 pt-5">欢迎您，</h3>
        <span class="pt-10">通过企业认证，发布优质货源。请按以下要求提交认证资料<span class="more"></span></span>
      </div>
      <div class="auth-body">
        <div class="auth-step">
          <div class="freightloan-step-box">
            <div
              :class="[
                {
                  active: activeIndex == idx,
                  hasActive: activeIndex > idx,
                  hasFinish: activeIndex > idx
                },
                'freightloan-step-item'
              ]"
              v-for="(item, idx) in setpArr"
              :key="idx"
            >
              <div style="display: inline-block">
                <div>
                  <span class="freightloan-step-item_circle">
                    <template v-if="idx >= activeIndex">{{ idx + 1 }}</template>
                  </span>
                  <span class="freightloan-step-item_title">{{ item }}</span>
                </div>
              </div>
              <div class="freightloan-step-arrow">
                <i v-if="idx !== setpArr.length - 1" class="freightloan-step-item_arrow el-icon-arrow-right"></i>
              </div>
            </div>
            <span class="apply-tip" :class="[activeIndex === 0 ? 'one' : 'two']" v-if="activeIndex !== 2">
              <span v-if="activeIndex == 0"
                >请准备好系统管理员身份证原件，完成管理员的实名认证。（注意：实名认证需采集系统管理员人脸信息，请务必保证管理员本人操作。）</span
              >
              <span v-if="activeIndex == 1"
                >请准备好以下资料，完成企业认证：1.企业营业执照 2.企业法人身份证照片
                3.如果系统管理员不是法人本人，请上传《企业委托书》</span
              >
            </span>
          </div>
        </div>
        <div class="auth-con">
          <div v-if="activeIndex == 0" class="auth-con-qr">
            <div class="qrcode">
              <img src="../../assets/img/passport/pic_qyewm.png" />
            </div>
            <p class="mt-5">请扫描上方二维码，下载<span class="font-bold">司机宝APP</span>，完成实名认证</p>
            <el-button type="primary" round @click="handleValid">已完成认证，下一步</el-button>
          </div>

          <div v-if="activeIndex == 1" class="auth-con-info">
            <certificate @submit="handleSubmit"></certificate>
          </div>

          <div v-if="activeIndex == 2" class="auth-success">
            <img class="reg-succed-img" src="../../assets/img//passport/ic_success.png" alt="" />
            <p class="dec">提交成功</p>
            <p class="time">预计审核时间3分钟</p>
          </div>
        </div>
      </div>
    </div>
    <!--实名认证-->
    <el-dialog :visible.sync="authStatus" title="提示" custom-class="tip-dialog" :close-on-click-modal="false">
      <p class="gray">
        <span class="auth-ic"> </span>
        请扫描页面上的二维码下载司机宝APP，并完成管理员实名认证
      </p>
      <div slot="footer">
        <el-button type="primary" @click="authStatus = false" round>知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { WUYI, vali } from '@/api/common';

import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import Certificate from '@/components/Certificate';
export default {
  components: {
    Certificate
  },
  data: function () {
    return {
      ssid: '',
      setpArr: ['系统管理员实名认证', '提交企业资料', '完成'],
      activeIndex: 0, // 当前在第几步
      authStatus: false // 实名认证状态
    };
  },
  created: function () {
    // this.getCertifyState();
  },
  methods: {
    getCertifyState() {
      axios.post(api.qryCompanyCertifyState, {}).then(res => {
        if (res.data.facadeCertifyState) {
          this.activeIndex++;
        }
      });
    },
    handleValid() {
      // 调接口查询认证状态
      axios.post(api.qryCompanyCertifyState, {}).then(res => {
        let adminCertifyState = res.data.adminCertifyState; // 系统管理员实名认证状态
        let companyCertifyState = res.data.companyCertifyState; // 企业认证状态
        let facadeCertifyState = res.data.facadeCertifyState; // 人脸认证状态
        if (!facadeCertifyState) {
          this.authStatus = true;
        } else {
          if (companyCertifyState == 0) {
            this.activeIndex++;
          } else {
            // 跳转到登录
            this.getMe();
          }
        }
      });
    },
    handleSubmit() {
      this.getMe();
    },
    async getMe() {
      let res = await axios.post(api.getCompanyLoginUser);
      localStorage.removeItem('webCompanyInfo');
      localStorage.setItem('webCompanyInfo', JSON.stringify(res.data)); //当前登录对象相关的全局数据
      window.location.href = './stock.html';
    }
  }
};
</script>
<style scoped>
.auth-wrap {
  width: 1000px;
  margin: 0 auto;
}
.auth-header {
  margin: 0 0 14px 0;
  display: flex;
  align-items: center;
}
.auth-header h3 {
  font-size: 30px;
  color: #58626b;
}
.auth-body {
  min-height: 700px;
}

.auth-step {
  background: #fff;
  border-top: 6px solid #1cc466;
  box-sizing: border-box;
  height: 154px;
}
.auth-con-qr {
  height: 600px;
  padding: 80px 0 140px 0;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
}
.auth-con-qr .qrcode {
  width: 196px;
  height: 196px;
  margin: 0 auto;
}
.auth-con-qr p {
  margin-bottom: 40px;
  color: #666;
}
.auth-success {
  height: 600px;
  padding: 80px 0 140px 0;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
}
.auth-success p.dec {
  margin: 5px 0;
  color: #424b53;
  font-size: 18px;
}
.auth-success p.time {
  color: #999;
  font-size: 14px;
}
.auth-ic {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url('../../assets/img/common/ico_smwrz@2x.png') no-repeat;
  background-size: 100%;
  margin-top: -3px;
  vertical-align: middle;
}

.auth-license {
  margin: 15px 0;
  padding: 36px;
  background: #fff;
}
.auth-con-info {
  margin-top: 20px;
}
.auth-con-info .title {
  margin-bottom: 20px;
  font-size: 16px;
  color: #778ca2;
}
.code {
  position: relative;
}
.code span {
  position: absolute;
  left: 400px;
  top: 0;
}
.idcard {
  display: flex;
}
.btn-group {
  padding: 30px 10px 0 40px;
  border-top: 1px solid #e8ecef;
}
.submit-btn {
  border: 1px solid #1cc466;
  color: #1cc466;
}
.freightloan-title {
  margin: 14px 0 24px 10px;
  color: #778ca2;
}
.freightloan-con {
  padding: 10px 10px 30px 10px;
  background: #fff;
}
.freightloan-step-box {
  position: relative;
  display: flex;
  align-items: center;
  margin: 40px 30px 0 30px;
  justify-content: center;
}
.freightloan-step-item_circle {
  display: inline-block;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  background: #c4cbd2;
  border-radius: 50%;
  color: #fff;
  text-align: center;
}
.freightloan-step-item_title {
  color: #c4cbd2;
}
.freightloan-step-item_arrow {
  margin: 0 24px 0 20px;
  color: #c4cbd2;
}
.freightloan-step-item.active .freightloan-step-item_circle,
.freightloan-step-item.hasActive .freightloan-step-item_circle {
  background: #1cc466;
}
.freightloan-step-item.hasFinish .freightloan-step-item_circle {
  background: url('../../assets/img/wallet/ico_yfdbz_ok.png') no-repeat;
  background-size: 24px 24px;
  vertical-align: middle;
}

.freightloan-step-item.hasActive .freightloan-step-item_title,
.freightloan-step-item.hasActive .freightloan-step-item_arrow {
  color: #58626b;
}
.freightloan-step-item.hasActive .freightloan-step-item_title:hover {
  cursor: pointer;
  color: #1cc466;
}
.freightloan-step-item.active .freightloan-step-item_title {
  color: #424b53;
  font-weight: bold;
}
.freightloan-step-item.active .freightloan-step-item_arrow {
  color: #424b53;
}
.apply-tip {
  position: absolute;
  top: 35px;
  left: 35px;
  height: 36px;
  border: 1px solid #f5dab1;
  background: #fffbf6;
  color: #ff9900;
  padding: 5px 20px;
  box-sizing: border-box;
  z-index: 2;
}
.apply-tip:before {
  content: '';
  position: absolute;
  top: -7px;
  left: 110px;
  background: #fffbf6;
  border: 1px solid #f5dab1;
  border-right: none;
  border-bottom: none;
  width: 12px;
  height: 12px;
  transform: rotate(45deg);
  z-index: 1;
}
.apply-tip.two:before {
  left: 420px;
}
.freightloan-step-arrow {
  padding: 0 50px;
  display: inline-block;
  vertical-align: top;
}
.pic-preview {
  width: 192px;
  height: 120px;
  background-size: 100% 100%;
}
.pic-preview img {
  width: 100%;
  height: 100%;
}
</style>

<style>
.auth-con-info .self-brefore .el-input__inner {
  width: 386px;
}
.auth-con-info .el-form-item__label {
  color: #90a0b1;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
.auth-header .more {
  margin-left: 5px;
  display: inline-block;
  width: 12px;
  height: 10px;
  background: url('../../assets/img/common/ico_ydxx_forwordgray@2x.png') no-repeat;
  background-size: 12px 10px;
  vertical-align: middle;
}
</style>
